import { Logger } from '../../logger/Logger';
import { DEFAULT_LANGUAGE_CODE } from '../../utils/language';
import { DictionaryType } from '../dictionary/constants';
import { DictionaryFetcher } from '../dictionary/DictionaryFetcher';
import { DictionaryService } from '../dictionary/DictionaryService';
import { DictionaryValueFormatter } from '../dictionary/DictionaryValueFormatter';
import type { DictionaryFragment } from '../dictionary/types';

import type { HelpFile } from './types';

const helpDictionaryFetcher = new DictionaryFetcher<HelpFile>(DictionaryType.Help, {
  onError: (file, locale): void => {
    Logger.logFailure('fetch', {
      place: 'helpDictionaryFetcher',
      additional: `${file}-${locale}`,
    });
  },
  parseFile: (file): DictionaryFragment => {
    const dictionaryFragment: DictionaryFragment = {};

    Object.entries(file).forEach(([chapterName, chapterValue]) => {
      Object.entries(chapterValue).forEach(([sectionName, sectionValue]) => {
        dictionaryFragment[chapterName + '.' + sectionName] = sectionValue;
      });
    });

    return dictionaryFragment;
  },
  fallbackLocale: DEFAULT_LANGUAGE_CODE,
});

const helpValueFormatter = new DictionaryValueFormatter();

export const HelpTranslations = new DictionaryService<HelpFile>(helpDictionaryFetcher, helpValueFormatter);

HelpTranslations.addEventListener('no-translation', (key): void => {
  Logger.logFailedTranslation(key, HelpTranslations.locale);
  console.warn(`No translation found for key: ${key}`);
});

HelpTranslations.addEventListener('fetch-failed', () => {
  Logger.logFailure('fetch', {
    place: 'HelpTranslations',
    additional: HelpTranslations.locale,
  });
});
